export const globalMaxWidth = 1250;
export const convocatoriaSesionesUrl = 'https://drive.google.com/file/d/1qkRxOJtBW1cFGWfgnCYGCISTvVJfNeGe/view'